export default __webpack_public_path__ + "logo_oms.f1b1871.svg";